import { MemberSuggestionDto, TopicSuggestionDto } from "models/ApiModels";
import * as coreApi from "api/Core";
import Session from "services/Session";

const apiGetMembersSuggestions = coreApi.getMemberSuggestions();
const apiGetTopicSuggestions = coreApi.getTopicSuggestions();

function getMembers(searchText: string): Promise<MemberSuggestionDto[]> {
    const inputValue = searchText.trim().toLowerCase();
    return apiGetMembersSuggestions.execute({ searchText: inputValue, usersOnly: true, excludeCurrentUser: false, offset: 0, take: 9999 });
}

function getTopics(searchText: string): Promise<TopicSuggestionDto[]> {
    const inputValue = searchText.trim().toLowerCase();
    return apiGetTopicSuggestions.execute({ userId: Session.user.id, searchText: inputValue, offset: 0, take: 9999, skipTopicAccessCheckFor: null });
}

export const quillMentionConfig = {
    mention: {
        allowedChars: /^[A-Za-z\sÁÉÍÓÚáéíóúÀÈÌÒÙàèìòùÇçÃãÕõÂÊÎÔÛãêîôûÅÄÖåäö]*$/,
        mentionDenotationChars: ["@", "#"],
        source: function (searchTerm: any, renderList: any, mentionChar: any) {
            new Promise<Array<any>>((resolve) => {

                if (mentionChar === "@") {
                    getMembers(searchTerm).then((data) => {
                        resolve(data.map((d) => ({ id: d.key, value: d.label })));
                    });
                }
                else if (mentionChar === "#") {
                    getTopics(searchTerm).then((data) => {
                        resolve(data.map((d) => ({ id: d.key, value: d.label })));
                    });
                }
                else {
                    resolve([]);
                }
            }).then((values) => {
                renderList(values, searchTerm);
            });
        }
    }
};